import { IAugmentedJQuery, IDocumentService, IOnChangesObject, IWindowService } from 'angular';
import { IFontFamilyModel } from '../../classes';
import template from './desktop-trial-popover.html';
import { PopoverController, PopoverService } from '../../../tn.popover/service.tn.popover';
import { ITrial, TrialService } from '../../providers/TrialService';
import { UserService } from '../../../tn.user/service.tn.user';

export type DesktopTrialPopoverState = 'login' | 'add' | 'success';

export class DesktopPopoverController extends PopoverController {
    // bindings
    family?: IFontFamilyModel;
    alignment: 'left' | 'right' | 'top' | 'bottom' = 'bottom';

    // locals
    state: DesktopTrialPopoverState = this.userService.isLoggedIn() ? 'add' : 'login';
    trial?: ITrial;
    isLoggedIn = this.userService.isLoggedIn();

    static $inject = [
        '$window',
        '$document',
        '$element',
        '$tnPopover',
        'tn.user.service',
        'trialService'
    ];
    constructor(
        protected $window: IWindowService,
        protected $document: IDocumentService,
        protected $element: IAugmentedJQuery,
        protected $tnPopover: PopoverService,
        protected userService: UserService,
        protected trialService: TrialService,
    ) {
        // the Popover controller expects the first child of the element
        // of the legacy popover structure. TODO: fix it.
        super($window, $document, $element.children().first());
    }

    $onInit(): void {
        // add self to popover service for global hides.
        this.$tnPopover.popovers.push(this);

        this.userService.login$.subscribe(() => {
            this.isLoggedIn = this.userService.isLoggedIn();
        });

        this.userService.logout$.subscribe(() => {
            this.isLoggedIn = this.userService.isLoggedIn();
        });

        this.trialService.trialByFamilyIdx$.subscribe(() => {
            this.update();
        });
    }

    $onChange(changes: IOnChangesObject): void {
        const family = changes.family;
        if (family && family.currentValue !== family.previousValue) {
            // update when family change
            this.update();
        }
    }

    update(): void {
        const trials = this.trialService.trialByFamilyIdx$.getValue();
        if (this.family && trials[this.family.id]) this.trial = trials[this.family.id];
        if (this.trial) this.state = 'success';
    }

    show(anchor?: Element | EventTarget | null): void {
        // since we share a single dialog for all buttons we need to reset
        // the state when the popover is shown.
        this.state = this.userService.isLoggedIn() ? 'add' : 'login';
        super.show(anchor);
    }

    onSubmitted(trial: ITrial): void {
        this.trial = trial;
    }
}


export const DesktopTrialPopoverComponent = {
    controller: DesktopPopoverController,
    template,
    bindings: {
        family: '<',
    },
};